import { FC } from 'react';
import { PlanInfoChip } from './PlanInfoChip';

export const IncludedFeatureChip: FC<{
  currentPlanIndex: number;
  targetPlanIndex: number;
  includedText: string;
  notIncludedText?: string;
  alwaysIncluded?: boolean;
}> = ({ currentPlanIndex = 0, targetPlanIndex, includedText, notIncludedText = '', alwaysIncluded = false }) => {
  const isChecked = alwaysIncluded || currentPlanIndex >= targetPlanIndex;
  const text = isChecked ? includedText : notIncludedText;
  return <PlanInfoChip checked={isChecked} text={text} />;
};
